import { AssetTypesImageVideo, FieldType, FilterFormDataModel, PROMPTS, WidthClass } from '@thehubz/client/core';
import { CustomClients } from '@thehubz/shared/branding';

export const lufthansaFilterFormData: FilterFormDataModel = {
  title: 'Asset',
  description: '',
  customClient: CustomClients.LufthansaMediacenter,
  formFields: [
    {
      formTypeId: '1',
      formFieldName: 'assetType',
      fieldType: FieldType.Dropdown,
      fieldLabel: $localize`Asset type`,
      placeholder: $localize`:placeholder:-- All types --`,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.WFull,
      subProjectFlag: false,
      disable: false,
      multiple: true,
      visible: true,
      options: AssetTypesImageVideo,
    },
    {
      formTypeId: '4',
      formFieldName: 'status',
      fieldType: FieldType.Dropdown,
      fieldLabel: $localize`Status`,
      placeholder: $localize`:placeholder:-- All Status --`,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.WFull,
      subProjectFlag: false,
      disable: false,
      visible: true,
      multiple: false,
      options: [],
    },
    {
      formTypeId: '4',
      formFieldName: 'brand',
      fieldType: FieldType.Dropdown,
      fieldLabel: $localize`User group`,
      placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.WFull,
      disable: false,
      formGroup: true,
      visible: true,
      multiple: false,
      options: [],
    },
  ],
};
